type ValidationIssue = {
  loc?: unknown;
  msg?: unknown;
  message?: unknown;
};

function validationIssueMessage(issue: unknown): string | null {
  if (!issue || typeof issue !== 'object') return null;

  const { loc, msg, message } = issue as ValidationIssue & { filename?: unknown };
  const text = typeof msg === 'string' && msg.trim()
    ? msg.trim()
    : typeof message === 'string' && message.trim()
      ? message.trim()
      : null;
  if (!text) return null;

  const filename = typeof (issue as { filename?: unknown }).filename === 'string'
    ? (issue as { filename: string }).filename.trim()
    : '';
  if (filename) return `${filename}: ${text}`;

  const location = Array.isArray(loc)
    ? loc.filter((part): part is string | number => typeof part === 'string' || typeof part === 'number')
      .filter((part) => part !== 'body')
      .join('.')
    : '';
  return location ? `${location}: ${text}` : text;
}

/**
 * Produces a safe, renderable API error message without exposing a validation
 * payload's raw input value (which may contain private user data).
 */
export function formatApiError(error: unknown, fallback: string): string {
  const response = error && typeof error === 'object'
    ? (error as { response?: { data?: { detail?: unknown } } }).response
    : undefined;
  const detail = response?.data?.detail;

  if (typeof detail === 'string' && detail.trim()) return detail.trim();

  if (Array.isArray(detail)) {
    const messages = detail
      .map(validationIssueMessage)
      .filter((message): message is string => Boolean(message));
    if (messages.length) return messages.join('; ');
  }

  const singleMessage = validationIssueMessage(detail);
  if (singleMessage) return singleMessage;

  const errorMessage = error && typeof error === 'object'
    ? (error as { message?: unknown }).message
    : undefined;
  return typeof errorMessage === 'string' && errorMessage.trim()
    ? errorMessage.trim()
    : fallback;
}
